// Originally generated from the single-file app (index.html) during the React migration.
// Edit freely: this file is now the source of truth.
import type { LegacyViewDefinition } from "@/domain/types";

export const LEGACY_DEFAULT_VIEWS: LegacyViewDefinition[] = [
  {
    id: "A",
    columnLayoutId: "ageGroups",
    detailsViewIds: ["A", "B", "C", "D", "E", "F"],
    chipDisplay: "hidden",
    label: {
      no: "Kunnskapsgrunnlag",
      en: "Knowledge foundation",
    },
    column: "Kunnskapsgrunnlag",
    type: "numericPrefix",
    classPrefix: "v",
    values: {
      "1": {
        label: {
          no: "Tiltak vurdert som evidensbasert i faggruppens rapport eller FHIs tiltaksgjennomgang (temanotat)",
          en: "Evidence base in accordance with advisory group proposition",
        },
        color: "#92D050",
      },
      "2": {
        label: {
          no: "Tiltak med gode skåringer hos Ungsinn.no (5, 4, sannsynlig, funksjonell, dokumentert",
          en: "Evidence base in accordance with Ungsinn.no",
        },
        color: "#A2CEC2",
      },
      "3": {
        label: {
          no: "Tiltak dokumentert i norsk studie med lovende resultat",
          en: "Supported by local research study",
        },
        color: "#DAC2EC",
      },
      "4": {
        label: {
          no: "Tiltak hvor faggruppens rapport anbefaler styrking av kunnskapsgrunnlag / utprøving",
          en: "Promising in accordance with advisory group proposition",
        },
        color: "#FFC90E",
        extraCSS:
          "background-image:repeating-linear-gradient(45deg,#92D050 0,#92D050 5px,#A6A6A6 5px,#A6A6A6 10px);",
      },
      "5": {
        label: {
          no: "Lovende tiltak, men ikke evaluert med tilstrekkelig kvalitet eller utprøvd i Norge",
          en: "Promising based on working group recommendation",
        },
        color: "#E9E9E9",
        extraCSS: "color:#000;",
      },
      "6": {
        label: {
          no: "Generisk støttetiltak",
          en: "Foundational component",
        },
        color: "#A6A6A6",
      },
      "7": {
        label: {
          no: "Annet",
          en: "Other",
        },
        color: "#1976D2",
      },
    },
  },
  {
    id: "B",
    columnLayoutId: "ageGroups",
    detailsViewIds: ["B", "C", "F"],
    chipDisplay: "view",
    label: {
      no: "Forebyggingsnivå",
      en: "Prevention level",
    },
    column: "InterventionLevel",
    type: "numericPrefix",
    classPrefix: "b",
    values: {
      "0": {
        label: {
          no: "Blank",
          en: "Blank",
        },
        color: "#ffffff",
        extraCSS: "color:#000;",
      },
      "1": {
        label: {
          no: "Universelt",
          en: "Universal",
        },
        color: "#6B9471",
      },
      "2": {
        label: {
          no: "Selektivt",
          en: "Selective",
        },
        color: "#F4C874",
        extraCSS: "color:#000;",
      },
      "3": {
        label: {
          no: "Indikativt",
          en: "Indicated",
        },
        color: "#BF5642",
      },
      "4": {
        label: {
          no: "Multilevel",
          en: "Multilevel",
        },
        color: "#cccccc",
      },
    },
  },
  {
    id: "C",
    columnLayoutId: "ageGroups",
    detailsViewIds: ["B", "C", "F"],
    chipDisplay: "view",
    label: {
      no: "RePS initiell sortering",
      en: "RePS initial classification",
    },
    column: "Initial_filtering",
    type: "numericPrefix",
    classPrefix: "c",
    values: {
      "1": {
        label: {
          no: "Forebygging",
          en: "Prevention",
        },
        color: "green",
      },
      "2": {
        label: {
          no: "Støttetjeneste",
          en: "Supporting services",
        },
        color: "#DF70E0",
      },
      "3": {
        label: {
          no: "Ikke forebygging",
          en: "Not prevention",
        },
        color: "#999999",
      },
      "4": {
        label: {
          no: "Trenger mer informasjon",
          en: "Need more information",
        },
        color: "yellow",
      },
    },
  },
  {
    id: "D",
    columnLayoutId: "ageGroups",
    detailsViewIds: ["A", "B", "C", "D", "E", "F"],
    chipDisplay: "hidden",
    label: {
      no: "Ressursbehov",
      en: "Resource requirement",
    },
    column: "Ressursbehov",
    type: "categorical",
    classPrefix: "r-",
    order: ["hoy", "middels", "lavt"],
    normalize: "resource",
    values: {
      hoy: {
        label: {
          no: "Høyt ressursbehov",
          en: "High resource requirement",
        },
        color: "#BF5642",
      },
      middels: {
        label: {
          no: "Middels ressursbehov",
          en: "Medium resource requirement",
        },
        color: "#F4C874",
        extraCSS: "color:#000;",
      },
      lavt: {
        label: {
          no: "Lavt ressursbehov",
          en: "Low resource requirement",
        },
        color: "#6B9471",
      },
    },
  },
  {
    id: "E",
    columnLayoutId: "ageGroups",
    detailsViewIds: ["A", "B", "C", "D", "E", "F"],
    chipDisplay: "hidden",
    label: {
      no: "Grunnmur (støtteelementer)",
      en: "Foundation (support elements)",
    },
    column: "Grunnmur",
    type: "categorical",
    classPrefix: "g-",
    order: ["ja", "nei"],
    values: {
      ja: {
        label: {
          no: "Grunnmur",
          en: "Foundation",
        },
        color: "#ff0000",
      },
      nei: {
        label: {
          no: "Ikke grunnmur",
          en: "Not foundation",
        },
        color: "#00ff00",
      },
    },
  },
  {
    id: "F",
    columnLayoutId: "ageGroups",
    detailsViewIds: ["B", "C", "F"],
    chipDisplay: "view",
    label: {
      no: "Evidensnivå (UNODC)",
      en: "Evidence level (UNODC)",
    },
    column: "EvidenceLevel",
    type: "numericPrefix",
    classPrefix: "f",
    values: {
      "1": {
        label: {
          no: "Evidence based",
          en: "Evidence based",
        },
        color: "#168B19",
      },
      "2": {
        label: {
          no: "Evidence based not locally evaluated",
          en: "Evidence based not locally evaluated",
        },
        color: "#4BCF4D",
      },
      "3": {
        label: {
          no: "Strongly evidence informed",
          en: "Strongly evidence informed",
        },
        color: "#A3DE63",
        extraCSS: "color:#000;",
      },
      "4": {
        label: {
          no: "Weakly evidence informed",
          en: "Weakly evidence informed",
        },
        color: "#FFC511",
        extraCSS: "color:#000;",
      },
      "5": {
        label: {
          no: "Non evidence based",
          en: "Non evidence based",
        },
        color: "#C20C15",
        extraCSS: "color:#fff;",
      },
      "6": {
        label: {
          no: "Innovative",
          en: "Innovative",
        },
        color: "#FDFC18",
        extraCSS: "color:#000;",
      },
      "7": {
        label: {
          no: "Supporting services",
          en: "Supporting services",
        },
        color: "#DF70E0",
      },
      "8": {
        label: {
          no: "Ikke forebygging / ikke relevant",
          en: "Not prevention / not relevant",
        },
        color: "#999999",
      },
      "9": {
        label: {
          no: "Duplikat",
          en: "Duplicate",
        },
        color: "#7A7A7A",
        extraCSS: "color:#fff;",
      },
    },
  },
  {
    id: "G",
    columnLayoutId: "tiltaksklasse",
    detailsViewIds: ["G", "B", "C", "D", "E", "F"],
    chipDisplay: "view",
    label: {
      no: "Tiltaksklasse (POD)",
      en: "Intervention category (POD)",
    },
    column: "Tiltaksklasse",
    type: "numericPrefix",
    classPrefix: "g",
    values: {
      "1": {
        label: {
          no: "Personorientert",
          en: "Person-oriented",
        },
        color: "#92D050",
      },
      "2": {
        label: {
          no: "Situasjonsorientert",
          en: "Situation-oriented",
        },
        color: "#A2CEC2",
      },
      "3": {
        label: {
          no: "Lokalorientert",
          en: "Local-oriented",
        },
        color: "#DAC2EC",
      },
      "4": {
        label: {
          no: "Multikomponent",
          en: "Multi-component",
        },
        color: "#999999",
      },
    },
  },
  {
    id: "Z",
    columnLayoutId: "ageGroups",
    detailsViewIds: ["B", "C", "F"],
    chipDisplay: "objectives",
    label: {
      no: "Målsetting",
      en: "Objectives",
    },
    column: "EvidenceLevel",
    type: "numericPrefix",
    classPrefix: "f",
    values: {
      "1": {
        label: {
          no: "Evidence based",
          en: "Evidence based",
        },
        color: "#168B19",
      },
      "2": {
        label: {
          no: "Evidence based not locally evaluated",
          en: "Evidence based not locally evaluated",
        },
        color: "#4BCF4D",
      },
      "3": {
        label: {
          no: "Strongly evidence informed",
          en: "Strongly evidence informed",
        },
        color: "#A3DE63",
        extraCSS: "color:#000;",
      },
      "4": {
        label: {
          no: "Weakly evidence informed",
          en: "Weakly evidence informed",
        },
        color: "#FFC511",
        extraCSS: "color:#000;",
      },
      "5": {
        label: {
          no: "Non evidence based",
          en: "Non evidence based",
        },
        color: "#C20C15",
        extraCSS: "color:#fff;",
      },
      "6": {
        label: {
          no: "Innovative",
          en: "Innovative",
        },
        color: "#FDFC18",
        extraCSS: "color:#000;",
      },
      "7": {
        label: {
          no: "Supporting services",
          en: "Supporting services",
        },
        color: "#DF70E0",
      },
      "8": {
        label: {
          no: "Ikke forebygging / ikke relevant",
          en: "Not prevention / not relevant",
        },
        color: "#999999",
      },
      "9": {
        label: {
          no: "Duplikat",
          en: "Duplicate",
        },
        color: "#7A7A7A",
        extraCSS: "color:#fff;",
      },
    },
  },
];
